<template>
    <div id="app">
        <div class="header add-fixed">
            <div class="logo_img" @click="OnClickedLogo">
                <div style="display:flex; align-items: center;justify-content: center; float:left; height: 65px;">
                    <div class="header-logo">
                        <img id="header-img" src="../../public/Moonee.png">
                    </div>
                </div>
            </div>
            <div></div>
            <div></div>

        </div>


        <div class="container" style="">
            <router-view></router-view>
        </div>
        <div id="back_to_top" ref="btn" @click="BackToTheTop" style="display: none;">
            <img src="../assets/smallStep/官网_slices/top.png" style="height: 43px;width: 43px" />
        </div>

        <div class="footerCopyRight">
            <h5 style="text-align: center; "><!-- Contact for Business: develpoer@legustudio.com <br>-->
                Copyright (c) 2022-2026 HongKong Moonee Technology Co., Ltd(香港墨逸科技有限公司) All rights reserved
            </h5>
        </div>
    </div>
</template>

        <script>

        export default {
            name: "Layout",
            data() {
                return {
                    activeIndex: '1',
                    scroll: '',
                    timer: '',
                    seen: true,
                    currentMenu: '首页'
                };
            },

            methods: {
                SelectMenuHandle(key) {
                    switch (key) {
                        case '1':
                            // this.$router.push({ name: "Index" });
                            window.location.hash = "#公司简介";
                            break;
                        case '2':
                            window.location.hash = "#我们的优势";
                            break;
                        case '3':
                            window.location.hash = "#公司产品";
                            break;
                        case '4':
                            window.location.hash = "#福利待遇";
                            break;
                        case '5':
                            window.location.hash = "#联系我们";
                            break;
                    }
                },
                SelectMenuHandleMobile(key) {
                    switch (key) {
                        case '1':
                            // this.$router.push({ name: "Index" });
                            this.currentMenu = '公司简介';
                            window.location.hash = "#公司简介";
                            break;
                        case '2':
                            this.currentMenu = '我们的优势';
                            window.location.hash = "#我们的优势";
                            break;
                        case '3':
                            this.currentMenu = '公司产品';
                            window.location.hash = "#公司产品";
                            break;
                        case '4':
                            this.currentMenu = '公司福利';
                            window.location.hash = "#福利待遇";
                            break;
                        case '5':
                            this.currentMenu = '联系我们';
                            window.location.hash = "#联系我们";
                            break;
                    }
                },
                ScrollHandle() {
                    this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
                    if (this.scroll > 600) {  //判断滚动后高度超过400px,就显示
                        this.$refs.btn.style.display = 'block';
                    } else {
                        this.$refs.btn.style.display = 'none'
                    }
                },

                BackToTheTop() { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
                    this.timer = setInterval(() => {
                        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                        let ispeed = Math.floor(-osTop / 5)
                        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                        if (osTop === 0) {
                            clearInterval(this.timer)
                        }
                    }, 20)
                },
                HandleMenuScreen() {
                    // 屏幕尺寸
                    let screenHeight = document.body.clientWidth;
                    if (screenHeight > 415) {
                        this.seen = true;
                    } else {
                        this.seen = false;
                    }
                },
                OnClickedLogo() {
                    this.$router.push({ name: "Index" });
                    this.currentMenu = '首页';
                },
            },
            mounted() {
                this.HandleMenuScreen()
                window.addEventListener('scroll', this.ScrollHandle, true);
            },
            beforeDestroy() {
                window.removeEventListener('scroll', this.ScrollHandle, true)
            },
        }
</script>

        <style scoped>
        @import '../assets/css/main.css';

        .el-menu--horizontal>.el-menu-item.is-active {
            border-bottom: 2px solid #FF6B11 !important;
        }

        .logo_img {
            /* float: left; */
            /* width: 30%; */
            /* margin: 0 auto; */
            /* width: 50%; */
            display: flex;
            height: auto;
            align-items: center;
            /* cursor: pointer; */
        }

        .el-menu-item {
            height: 100%;
            display: flex;
            align-items: center;
            font-size: 1em;
            font-size: 16px;
            font-weight: bold;
        }

        #back_to_top {
            position: fixed;
            bottom: 8   0px;
            right: 5vw;
            cursor: pointer
        }

        .header-title {
            font-size: 1em;
        }

        .company_name {
            font-weight: 600;
            font-size: 1.225em;
            margin-left: 1em;
            font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Nimbus Sans L", Arial, "Liberation Sans", "Hiragino Sans GB", "Source Han Sans CN Normal", "Microsoft YaHei", "Wenquanyi Micro Hei", "WenQuanYi Zen Hei", "ST Heiti", SimHei, "WenQuanYi Zen Hei Sharp", sans-serif;

        }

        .footer_font {
            font-size: 1em;
        }

        #menu_index {
            float: left;
            /* width: 45%; */
            width: auto;
            height: 100%
        }

        .header {
            margin: 0 auto;
            width: 100%;
            height: 54px;
            /* height: 46px; */
            display: flex;
            justify-content: space-around;
            align-items: center;
            background-color: #fff;
            /* justify-content: space-around; */
            /* opacity: 0.5; */
        }

        .showTopMenu {
            opacity: 255;
            transition: opacity .25s ease-in-out;
        }

        .hideTopMenu {
            opacity: 0;
            transition: opacity .25s ease-in-out;
        }

        @media screen and (max-device-width: 415px) {

            .el-submenu__title {
                border-bottom: 2px solid #FF6B11 !important;
            }

            .header {
                display: flex;
                justify-content: center;
            }

            .logo_img {
                /* float: left; */
                /* width: auto; */
                cursor: pointer;
                width: 50%;
                margin: 0 auto;
            }

            #back_to_top {
                position: fixed;
                bottom: 50px;
                /* right: 5px; */
                right: 10px;
                cursor: pointer
            }

            .footer_font {
                font-size: 0.875em;
            }

            #menu_index {
                float: right;
                width: auto;
                height: 100%
            }

            .footer {
                font-size: 0.1em;
                text-align: center;
                justify-content: space-between;
            }

            .footer span {
                width: 33%;
            }
        }

        #header-img {

            /* width: 50px;
    height: 50px; */
            /* width: 187.25px;
    height: 58.2px; */
            /* 3745*1164 */
            height: 34px;
            width: 114.5px;
            /* height: 29px;
    width: 97px; */
            float: left;
            margin: auto;
            cursor: pointer;
        }

        .header-important {
            float: left;
            margin-left: 6px;
            align-self: center;
        }

        a {
            text-decoration: none;
        }

        a:visited {
            text-decoration: none;
        }

        a:hover {
            text-decoration: none;
        }

        a:active {
            text-decoration: none;
        }

        .footerCopyRight {
            margin-top: 0em;
            position: absolute;
            width: 100%;
            height: 50px;
            background: rgba(235, 236, 237, .4);
        }

        .footerCopyRight h5 {
            margin-right: 1rem;
            margin-left: 1rem;
            font-size: 0.88em;
            line-height: 0.88em;
        }

        h5 {
            display: block;
            font-size: 0.83em;
            margin-block-start: 1.67em;
            margin-block-end: 1.67em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            font-weight: bold;
            unicode-bidi: isolate;
        }
    </style>
